import { render, staticRenderFns } from "./SendSafetyConfirmToOtherUserInput.vue?vue&type=template&id=6221f840&lang=pug"
import script from "./SendSafetyConfirmToOtherUserInput.vue?vue&type=script&lang=ts"
export * from "./SendSafetyConfirmToOtherUserInput.vue?vue&type=script&lang=ts"
import style0 from "./SendSafetyConfirmToOtherUserInput.vue?vue&type=style&index=0&id=6221f840&prod&lang=scss&scopeed=true"
import style1 from "./SendSafetyConfirmToOtherUserInput.vue?vue&type=style&index=1&id=6221f840&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports